import { Select, Table } from "antd";
import { getCryptoTrans } from "../../../api/trade";
import { cryptoTradeColumn } from "../../customers/column";
import { useQuery } from "react-query";
import { useState } from "react";
import CryptoDetail from "./CryptoDetail";

const Crypto = () => {
  const [cryptoType, setCryptoType] = useState("");
  const [page, setPage] = useState(1);
  const [transactions, setTransactions] = useState([]);

  const { data, isFetching } = useQuery(
    ["trade-history", cryptoType, page],
    () => getCryptoTrans(cryptoType, page),
    {
      onSuccess: (res) => {
        setTransactions(res?.transactions);
      }
    }
  );
  const [open, setOpen] = useState(false);
  const [singleData, setSingleData] = useState({});

  const handleRowClick = (record) => {
    setSingleData(record || {});
    setOpen(true);
  };

  return (
    <div>
      <CryptoDetail open={open} setOpen={setOpen} record={singleData} />
      <Select
        onSelect={(val) => setCryptoType(val)}
        placeholder="Filter By Type"
        className="my-5 w-[250px]"
      >
        <Select.Option value="buy">Buy</Select.Option>
        <Select.Option value="sell">Sell</Select.Option>
        <Select.Option value="receive">Receive</Select.Option>
        <Select.Option value="send">Send</Select.Option>
      </Select>
      <Table
        loading={isFetching}
        dataSource={transactions}
        columns={cryptoTradeColumn}
        rowClassName="cursor-pointer hover:bg-gray-50"
        onRow={(record) => {
          return {
            onClick: () => handleRowClick(record),
          };
        }}
        pagination={{
          current: page,
          pageSize: 20,
          total: data?.total || 1,
          showSizeChanger: true,
          onChange: (newPage) => {
            setPage(newPage);
          },
        }}
      />
    </div>
  );
};

export default Crypto;
